import { LoadingSpinner } from 'components/LoadingSpinner'
import { handleError } from 'containers/PageLogin/util'
import { useFormik } from 'formik'
import { useState } from 'react'
import toast from 'react-hot-toast'
import { IoMdClose } from 'react-icons/io'
import { fetchCreateEmployees } from 'services/fetch-create-employee'

import { validationSchema } from './schema'
import { FormValues, ModalEmployeesProps } from './type'

export function ModalEmployees({
  setModalEmployees,
}: Readonly<ModalEmployeesProps>) {
  const [loading, setLoading] = useState(false)
  const [closeModal, setCloseModal] = useState(false)

  const formikEmployees = useFormik<FormValues>({
    initialValues: {
      name: '',
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true)
      const data = {
        name: values.name,
        email: values.email,
      }

      fetchCreateEmployees(data)
        .then((res) => {
          if (res.message === 'Employee created successfully') {
            toast.success('Colaborador cadastrado com sucesso')
          }
          if (res.detail === 'Employee already exists') {
            toast.error('Colaborador já cadastrado')
          }
        })
        .catch(() => {
          setLoading(false)
          toast.error('Erro ao cadastrar colaborador')
        })
        .finally(() => {
          setLoading(false)
          if (closeModal) setModalEmployees(false)
          formikEmployees.resetForm()
        })
    },
  })

  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 shadow-2xl">
      <div className="bg-white m-4 md:m-auto w-[25rem] relative dark:bg-neutral-800 p-4 rounded-2xl shadow-lg">
        <div className="flex-1 flex justify-center gap-2 items-center">
          <h1 className="flex text-xl font-bold text-center">
            Cadastro de Colaboradores
          </h1>
          <button
            className="text-neutral-500 dark:text-neutral-400 absolute top-4 right-4"
            onClick={() => {
              setModalEmployees(false)
              window.location.reload()
            }}
          >
            <IoMdClose size={20} />
          </button>
        </div>
        <form className="w-full mt-4" onSubmit={formikEmployees.handleSubmit}>
          <section className="w-full h-full flex flex-col justify-start items-start">
            <div className="mb-4 w-full relative">
              <label
                htmlFor="passwordDefault"
                className="block text-sm font-medium text-neutral-900 dark:text-neutral-300"
              >
                Primeiro Nome
              </label>
              <input
                type="text"
                name="name"
                id="name"
                value={formikEmployees.values.name}
                onChange={formikEmployees.handleChange}
                onBlur={formikEmployees.handleBlur}
                className={`${handleError('name', formikEmployees)} block w-full mt-2 px-3 py-2 border-neutral-300 dark:border-neutral-700 rounded-full shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent`}
              />
              {formikEmployees.touched.name && formikEmployees.errors.name ? (
                <p className="text-red-500 text-xs mt-1">
                  {formikEmployees.errors.name}
                </p>
              ) : null}
            </div>
            <div className="mb-4 w-full relative">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-neutral-900 dark:text-neutral-300"
              >
                E-mail Profissional
              </label>
              <input
                type="email"
                name="email"
                id="email"
                value={formikEmployees.values.email}
                onChange={formikEmployees.handleChange}
                onBlur={formikEmployees.handleBlur}
                className={`${handleError('email', formikEmployees)} block w-full mt-2 px-3 py-2 border-neutral-300 dark:border-neutral-700 rounded-full shadow-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent`}
              />
              {formikEmployees.touched.email && formikEmployees.errors.email ? (
                <p className="text-red-500 text-xs mt-1">
                  {formikEmployees.errors.email}
                </p>
              ) : null}
            </div>
          </section>
          <div className="w-full flex mt-4 gap-2 justify-between items-center">
            <button
              type="button"
              className={`
                bg-neutral-200 hover:bg-neutral-400/60 dark:bg-neutral-700
                hover:dark:bg-neutral-700/60 transition-colors duration-500
                ease-in-out text-neutral-900 dark:text-neutral-200 px-6
                py-2 rounded-full disabled:cursor-not-allowed disabled:bg-neutral-200
                disabled:hover:bg-neutral-200 dark:disabled:bg-neutral-700
                dark:disabled:hover:bg-neutral-700 text-sm md:text-base w-1/3
              `}
              onClick={() => {
                setModalEmployees(false)
              }}
              disabled={formikEmployees.isSubmitting}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className={`
                bg-[#4F46E5] hover:bg-[#4F46E5]/80 hover:dark:bg-[#4F46E5]/60
                transition-colors duration-500 ease-in-out text-white w-1/3 text-sm md:text-base
                md:px-6 md:py-2 px-4 py-2 rounded-full disabled:cursor-not-allowed disabled:bg-[#4F46E5]
                disabled:hover:bg-[#4F46E5] dark:disabled:bg-[#4F46E5] flex justify-center items-center
              `}
              disabled={
                formikEmployees.isSubmitting ||
                !formikEmployees.isValid ||
                loading
              }
              onClick={() => {
                if (!loading) {
                  setCloseModal(true)
                  window.location.reload()
                }
              }}
            >
              {loading ? <LoadingSpinner /> : 'Cadastrar'}
            </button>
            <button
              type="submit"
              className={`
                bg-[#4F46E5] hover:bg-[#4F46E5]/80 hover:dark:bg-[#4F46E5]/60
                transition-colors duration-500 ease-in-out text-white w-[18rem]
                px-4 h-11 py-1 rounded-full disabled:cursor-not-allowed disabled:bg-[#4F46E5]
                disabled:hover:bg-[#4F46E5] dark:disabled:bg-[#4F46E5] flex justify-center items-center
              `}
              disabled={
                formikEmployees.isSubmitting ||
                !formikEmployees.isValid ||
                loading
              }
              onClick={() => setCloseModal(false)}
            >
              {loading ? (
                <LoadingSpinner />
              ) : (
                <p className="text-xs">Cadastrar e incluir outro</p>
              )}
            </button>
          </div>
        </form>
      </div>
    </section>
  )
}
